export default __webpack_public_path__ + "4d806e1108c07926f7447564795417ed.png";